<template>
    <div
        class="w-full flex justify-center flex-col bg-white p-8 box-border"
    >
        <div class="flex items-center flex-col md:flex-row">
            <div class="relative overflow-hidden aspect-thumbnail place-self-start md:place-self-auto h-48" v-if="hasThumbnail">
                <img
                    v-if="hasThumbnail"
                    class="w-full rounded-t"
                    :src="article.thumbnail"
                    loading="lazy"
                    alt="thumbnail"
                />
            </div>
          <div class="w-full flex flex-col flex-1 place-self-start text-justify xxs:mt-4 md:mt-0" :class="hasThumbnail && 'md:px-4'">
              <h2 class="text-justify xxs:text-xl lg:text-2xl overflow-hidden overflow-ellipsis max-h-[66px] multi-line-ellipsis clamp-3-lines">{{ article.title }}</h2>
              <div v-html="processedHtml" class="mt-8 text-body-6 text-default-2 w-full overflow-hidden overflow-ellipsis max-h-[60px] multi-line-ellipsis clamp-3-lines"/>
              <div class="flex flex-1"></div>
          </div>
        </div>
        <router-link
            :to="`/public-news/${article.uid}`"
            class="self-start text-body-6 p-4 rounded mt-8 bg-gray-300 text-black"
        >
            Read more
        </router-link>
    </div>
    <hr class="w-[90%] last:hidden" />
</template>

<script setup>
import {computed} from "vue";

const props = defineProps({
    article: {
        type: Object,
        required: true
    },
})

const hasThumbnail = computed(() => {
    if(!props.article || props.article.thumbnail === null) {
        return false;
    }

    return props.article.thumbnail.length > 0;
});

const processedHtml = computed(() => {
    const articleBody = props.article.body.replace(/<img[^>]*>/g, '');
    return articleBody.replace(/<iframe[^>]*>/g, '');
});
</script>